<div class="mx-space-sm" appStopPropagation>
  @let profile = this.profile$ | async;
  <cam-loader [isLoading]="this.requestState.isLoading()">
    <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
      <cam-empty [isEmpty]="!profile">
        <div class="bdp-b color-border-primary">
          <div class="pt-space-xs m-xs">
            <cam-inline-profile-data
              [profile]="profile ?? {}"
              [userLogo]="this.userLogo$ | async"
              (click)="this.navigateToProfile()"
            ></cam-inline-profile-data>
            @if (this.isEditable()) {
              <div class="my-space-md">
                <cam-button (action)="this.navigateToEditProfile()" [style]="'secondary'">
                  <div class="align-center button-content">
                    <cam-font-icon name="modify" type="lg" class="mr-space-xs modify-icon"></cam-font-icon>
                    <div class="text">
                      {{ 'user.modify' | translate }}
                    </div>
                  </div>
                </cam-button>
              </div>
            }
          </div>
        </div>
      </cam-empty>
    </cam-error>
  </cam-loader>

  @if (this.profileMenu(); as profileMenu) {
    <div class="bdp-b color-border-primary pt-space-xs">
      <cam-menu [menu]="profileMenu" [style]="'dark'"></cam-menu>
    </div>
  }
  @if (this.disconnectionMenu(); as disconnectionMenu) {
    <div class="bdp-b pt-space-xs">
      <cam-menu [menu]="disconnectionMenu" [style]="'dark'"></cam-menu>
    </div>
  }
  <div class="ta-c">
    <small>{{ this.appVersion() }}</small>
  </div>
</div>

<ng-template #languageTemplate>
  <cam-switch-language></cam-switch-language>
</ng-template>

<ng-template #infosTemplate>
  @if (this.infosMenu(); as infosMenu) {
    <div class="mx-space-sm info-panel">
      <cam-menu [menu]="infosMenu" [style]="'dark'"></cam-menu>
    </div>
  }
</ng-template>
